<template>
    <div class="link-node-warp">
        <h4>프로토콜 기본정보</h4>
        <div class="link-item">
            <button class="EQUIPMENT"
                    @dblclick="tagPopOn('EQUIPMENT')"
                    :class="nodeLinkData['EQUIPMENT'].active === false ? 'disabled' : ''"
                    :data-items="nodeLinkData['EQUIPMENT'].text"
            ><span>장비</span><b>{{ nodeLinkData['EQUIPMENT'].text }}</b></button>
        </div>
        <TagOptionPopTagList/>
    </div>
</template>

<script>
  import mixin from "@/mixins/process";
  import CommNew from "@processEditor/CommNew";
  import {checkProtocolLink} from '@mixins/makeLinkInfo.js';
  import TagOptionPopTagList from '@components/TagAddPop/TagOptionPopTagList' ; 
  import { TagAddPopCommMapMutations } from "@TagAddPop/TagAddPopComm"; 

  export default {
    mixins:[mixin, CommNew],
    props : {
        processInfoSetOn : Boolean
    } , 
    components : {
        TagOptionPopTagList
    } , 
    data () {
      return {
        nodeLinkData : {
                EQUIPMENT : {label:'장비',text:'장비',key:null,category:'EQUIPMENT',active:false},
            },
        disabledNames : ["장비","프로토콜 기본폼"],
        nodeLinkValidData : { "EQUIPMENT" : false, },
      }
    } , 
    async mounted () {
        // let { nodes, links, protocols } = this.PROCESS_INFO ; 
        this.initData();
        this.initFunc();
    } , 
    watch : {
        processInfoSetOn : function(on){
            if( on === true ) this.initFunc();
        },
        '$route.query.protocolId' : function(protocolId){
            if( protocolId ) this.initFunc();
        }
    } , 
    methods : {
        ...TagAddPopCommMapMutations([
            'setTagOptionPopAddListViewBln' , 
            'setCrntTagType' , 
            'setCallbackFunc' , 
        ]) ,        
        async tagChangeHandler( tagInfo ){
            let { name, tagType, id } = tagInfo;
            let active = !this.disabledNames.includes(name);
            this.nodeLinkData[tagType].text = name;
            this.nodeLinkData[tagType].active = active;
            this.nodeLinkValidData[tagType] = active;

            this.nodeLinkValid();

            let { key, label } = this.nodeLinkData[tagType];
            let { links, nodes, protocols } = this.PROCESS_INFO;
            let { protocolId } = this.$route.query;
            
            let selectNode = nodes.find(o=>o.key===key)
            selectNode.tagId = id;
            selectNode.text = name;
            selectNode.label = label;
            selectNode.category = tagType;
            const nodeData = {
                json: {
                    nodes, 
                    links
                },
            }

            try {
                const response = await this.$wApi.process.put( {...nodeData}, this.$route.query.processId);
                const crntProtocol = protocols.filter(o=>o.id === protocolId)[0];
                // console.log( "crntProtocol", crntProtocol )
                let putData = {
                    "protocolId": crntProtocol.id,
                }
                let nodeInfo = checkProtocolLink(links, nodes, this.$route.query.keyOfProtocol);
                nodeInfo = nodeInfo.nodeInfo;
                for(let item of Object.entries(nodeInfo)) {
                    // putData[item[0].toLowerCase()] = (Object.keys(item[1])).join(';');
                    putData[item[0].toLowerCase()] = Object.keys(item[1])[0];
                }
                // protocol content update시 장비의 경우 tagId와 넣어줌.
                if(tagType == "EQUIPMENT"){
                    putData.idEquipment = id;
                }
                await this.$wApi.protocol.put(putData);
                await this.status.issueListStatus.reload();
            } catch (error) {
                console.log(error)
            }                   
        },
        async tagPopOn(category){
            // 해당 프로토콜이 공개 상태인지 확인.
            const processDetail = await this.$wApi.process.detail(null, this.$route.query.processId ) ; 
            const publicActive = processDetail.publicActive;
            if(publicActive == 0){
                // 비공개 상태에서만 수정 팝업을 open
                let {label} = this.nodeLinkData[category]
                this.setCallbackFunc(this.tagChangeHandler);
                this.setCrntTagType({
                    tag: {
                        name: label,
                        type: category,
                    }
                });
                this.setTagOptionPopAddListViewBln({bln: true});
            }else{
                window.alert("<b>이미 공개된 프로토콜의 경우<br/>연결된 재료,목적,장비를 수정할 수 없습니다.</b>");
                return;
            }
        },
        initData(){
            this.nodeLinkData = {
                EQUIPMENT : {label:'장비',text:'장비',key:null,category:'EQUIPMENT',active:false},
            };
        },
        nodeLinkValid(){
            if( Object.values(this.nodeLinkValidData).includes(false) ){
                this.$emit('change', false )
            }else{
                this.$emit('change', true )
            }
        },
        initFunc(){
            this.initData();
            let { protocolId, keyOfProtocol } = this.$route.query ; 
            let { links, nodes } = this.PROCESS_INFO;
            if( !protocolId ) return;

            const linkData = checkProtocolLink(links,nodes,keyOfProtocol);
            for( let node of linkData.nodes ){
                let active = !this.disabledNames.includes(node.text);
                let { text, key, category, label } = node;
                this.nodeLinkData[category] = { text, key, category, label, active };
                this.nodeLinkValidData[category] = active;
            }

            this.nodeLinkValid();
        }
    }
  }
</script>

<style lang="scss" scoped>
.link-node-warp{
    position:fixed;
    right:20px;
    top:300px;
    width:250px;
    border:1px solid #ccc;
    padding:20px 20px 40px;
    border-radius:8px;
    background:#fff;
    z-index:11;    
    h4{
        font-size:16px;
        font-weight:bold;
        text-align: center;
    }
    .link-item{
        display:flex;
        margin-top:30px;
        flex-wrap: wrap;
        button{
            position:relative;
            width:100%;
            height:34px;
            padding:8px;
            border-radius:4px;
            color:#fff;
            font-size:13px;
            background: $color-equipment;
            border: 1px solid $color-border-equipment;
            &:after {
                visibility: hidden;
                content: attr(data-items);
                display: block;
                position: absolute; top:105%; right: 0;
                max-width: 220px;
                padding: 8px;
                border-radius: 3px;
                color: #000000;
                font-size: 12px;
                white-space: nowrap;
                background: $color-equipment;
                border: 1px solid $color-border-equipment;
                z-index: 5;
            }
            &:hover {
                &::after {
                    visibility: visible;
                }
            }            
            b{
                display:block;
                color: black;
                text-align:center;
                overflow:hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            span{
                position:absolute;
                display:flex;
                align-items: center;
                justify-content: center;
                top:-12px;
                left:-20px;
                height:24px;width:40px;
                padding:4px 6px;
                border-radius:40px;
                background: $color-equipment;
                border:1px solid $color-border-equipment;
                color: black;
            }
            &.disabled{
                background:#999;
                &:hover {
                    &::after {
                        visibility: hidden;
                    }
                }                 
                // span{ border:1px solid #999;color:#999;}
            }
        }
    }
}
</style>